(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offer-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('offer-countdown')) {
    customElements.define(
      'offer-countdown',
      class OfferCountdown extends HTMLElement {
        connectedCallback() {
          this.end = Number(this.dataset.end) * 1000;
          this.units = {};
          this.querySelectorAll('[data-unit]').forEach((element) => {
            this.units[element.dataset.unit] = element;
          });
          this.tick();
          this.interval = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }

        tick() {
          const remaining = Math.floor((this.end - Date.now()) / 1000);
          if (!this.end || remaining <= 0) {
            clearInterval(this.interval);
            this.remove();
            return;
          }
          const values = {
            days: Math.floor(remaining / 86400),
            hours: Math.floor((remaining % 86400) / 3600),
            minutes: Math.floor((remaining % 3600) / 60),
            seconds: remaining % 60,
          };
          Object.entries(values).forEach(([unit, value]) => {
            if (this.units[unit]) this.units[unit].textContent = String(value).padStart(2, '0');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-sticky-bar')) {
    customElements.define(
      'product-sticky-bar',
      class ProductStickyBar extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.stickyButton = this.querySelector('.product-sticky-bar__button');
          this.stickyLabel = this.querySelector('[data-sticky-label]');
          this.stickyPrice = this.querySelector('[data-sticky-price]');
          if (!this.mainButton) {
            this.remove();
            return;
          }

          this.mediaQuery = window.matchMedia('(max-width: 989px)');
          this.frameRequested = false;
          this.onScroll = () => {
            if (this.frameRequested) return;
            this.frameRequested = true;
            requestAnimationFrame(() => {
              this.frameRequested = false;
              this.updateVisibility();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });

          this.buttonObserver = new MutationObserver(() => this.syncButton());
          this.buttonObserver.observe(this.mainButton, {
            attributes: true,
            attributeFilter: ['disabled'],
            childList: true,
            subtree: true,
            characterData: true,
          });

          this.onMediaChange = () => this.updateVisibility();
          this.mediaQuery.addEventListener('change', this.onMediaChange);

          this.subscribeToVariantChanges();
          this.syncButton();
          this.updateVisibility();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          this.buttonObserver?.disconnect();
          this.mediaQuery?.removeEventListener('change', this.onMediaChange);
          if (this.unsubscribe) this.unsubscribe();
          document.body.classList.remove('has-product-sticky-bar');
        }

        subscribeToVariantChanges() {
          const subscribeNow = () => {
            if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (event.data.sectionId !== this.sectionId) return;
              this.syncPrice();
            });
          };

          if (typeof subscribe === 'function') {
            subscribeNow();
          } else if (document.readyState !== 'complete') {
            document.addEventListener('DOMContentLoaded', subscribeNow, { once: true });
          }
        }

        syncPrice() {
          const mainPrice = document.querySelector(`#price-${this.sectionId} .price`);
          if (!mainPrice || !this.stickyPrice) return;
          this.stickyPrice.innerHTML = mainPrice.outerHTML;
        }

        syncButton() {
          const mainLabel = this.mainButton.querySelector('span');
          this.stickyButton.disabled = this.mainButton.hasAttribute('disabled');
          if (mainLabel && this.stickyLabel) this.stickyLabel.textContent = mainLabel.textContent.trim();
        }

        updateVisibility() {
          const show = this.mediaQuery.matches && this.mainButton.getBoundingClientRect().bottom < 0;
          if (show === this.classList.contains('is-visible')) return;
          this.classList.toggle('is-visible', show);
          this.toggleAttribute('inert', !show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('has-product-sticky-bar', show);
          if (show) {
            document.body.style.setProperty('--product-sticky-bar-height', `${this.offsetHeight}px`);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-heart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wishlist-toggle')) {
    const STORAGE_KEY = 'cctvhaat-wishlist';
    const pageMemory = new Set();
    let storageAvailable = true;

    const readWishlist = () => {
      if (!storageAvailable) return [...pageMemory];
      try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(value) ? value : [];
      } catch (error) {
        storageAvailable = false;
        return [...pageMemory];
      }
    };

    const writeWishlist = (handles) => {
      pageMemory.clear();
      handles.forEach((handle) => pageMemory.add(handle));
      if (!storageAvailable) return;
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
      } catch (error) {
        storageAvailable = false;
      }
    };

    customElements.define(
      'wishlist-toggle',
      class WishlistToggle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.sync = this.sync.bind(this);
          this.button.addEventListener('click', () => this.toggle());
          document.addEventListener('wishlist:change', this.sync);
          window.addEventListener('storage', this.sync);
          this.sync();
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:change', this.sync);
          window.removeEventListener('storage', this.sync);
        }

        toggle() {
          const handle = this.dataset.handle;
          const handles = readWishlist();
          const saved = handles.includes(handle);
          writeWishlist(saved ? handles.filter((item) => item !== handle) : [...handles, handle]);
          document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle, saved: !saved } }));
        }

        sync() {
          const saved = readWishlist().includes(this.dataset.handle);
          this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
